<template>
  <header class="apps-header" :class="{'show': visible}">
    <router-link :to="'/home'" class="logo">
      <img src="/static/images/logo.svg" alt="">
      <span>浙江宇脉企业智能管理系统</span>
    </router-link>

    <div class="apps-header-icons" v-if='$store.state.userInfo.status == 2'>
      <router-link :to="'/message'" class="icon-button" style="vertical-align: middle;">
        <Badge :count="$store.state.badge.message" dot>
          <Icon type="md-mail"></Icon>
        </Badge>
      </router-link>
      <router-link :to="'/me'" class="icon-button" style="vertical-align: middle;" v-if="userInfo">
        <Icon type="md-person"></Icon>
      </router-link>
      <router-link :to="'/logs'" class="icon-button" style="vertical-align: middle;" v-if="$store.state.userInfo.role <= 1||$store.state.userInfo.nodes[0] == 'all'">
        <Icon type="ios-speedometer"></Icon>
      </router-link>
      <span class="mgui-toggle-menu" @click="$routeTo('/center')">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </span>
    </div>
    <div class="apps-header-icons" v-else>
      <Tag>请办理入职手续</Tag> <Button type="text" @click="$parent.spinShow = true;$store.dispatch('logout');$Message.success('成功退出')">退出登录</Button>
    </div>
  </header>
</template>

<script>

export default {
  name: 'Header',
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      direction: 'left',
      index: 0,
      messageCount: 1
    }
  },
  watch: {
    $route (to, from) {
      this.direction = to.meta.sort > from.meta.sort ? 'left' : 'right'
      // let routerActive = document.querySelector('.router-link-active')
      // let _class = routerActive[0].getAttribute('class')
      // routerActive.setAttribute('class', _class + ' ' + this.direction)
    }
  },
  computed: {
    userInfo: function () {
      return this.$store.state.userInfo
    }
  },
  methods: {
    avatar (image) {
      let avatar = image === null ? '/static/images/apps_logo.svg' : image
      return avatar
    },
    openLoginBox () {
      this.$store.dispatch('activeWindow', 'loginBox')
    },
    openRegBox () {
      this.$store.dispatch('activeWindow', 'regBox')
    },
    // 判断相对位置，设置下划线进入离开方向
    mouseEnter () {
      let e = document.event || window.event
      let obj = e.target
      let routerActive = document.querySelector('.main-nav .router-link-active')
      let index = obj.getAttribute('index')
      if (routerActive) this.direction = routerActive.getAttribute('index') < index ? 'left' : 'right'
      if (routerActive) routerActive.parentElement.setAttribute('class', this.direction)
      obj.setAttribute('class', this.direction === 'left' ? 'right' : 'left')
    },
    mouseLeave () {
      let e = document.event || window.event
      let obj = e.target
      obj.removeAttribute('class')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* .web-header */
  .apps-header{
    margin: 0 auto;
    padding: 10px 20px 5px;
    background-color: #fff;
    /*box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);*/
    -webkit-transition: all .5s linear 0s;
    transition: all .5s linear 0s;
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%);
    position: relative;
    border-bottom: 1px solid #ddd;
    z-index: 2
  }
  .apps-header.show{
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  .apps-header .logo{display:block;font-size: 18px;line-height: 25px;}
  .apps-header .logo img{height:25px;vertical-align: top;}
  .apps-header .logo span{vertical-align: middle;}

  .apps-header-icons{
    position: absolute;
    top: 10px;
    right: 15px;
  }
  .apps-header-icons .ivu-icon{
    font-size: 24px;
  }
  .apps-header-icons .icon-button{
    width: 30px;
    height: 22px;
    display: inline-block;
    text-align: center;
    margin-right: 10px;
  }
  .mgui-toggle-menu{
    width: 30px;
    height: 22px;
    display: inline-block;
    position: relative;
    top: 0;
    float: right;
    cursor: pointer;
    background-color: transparent;
  }
  .mgui-toggle-menu .bar{
    width: 20px;
    height: 2px;
    position: absolute;
    top: 2px;
    left: 5px;
    background-color: #333;
    -webkit-transition: all .2s linear 0s;
    transition: all .2s linear 0s;
  }
  .mgui-toggle-menu .bar:nth-child(2){
    top: 10px;
  }
  .mgui-toggle-menu .bar:nth-child(3){
    top: 18px;
  }
  .mgui-toggle-menu:hover{
    animation: again-right 1.5s linear infinite;
  }
  .mgui-toggle-menu:hover .bar:nth-child(1){
    width: 15px;
    -webkit-transform: rotate(30deg);
    transform: rotate(30deg);
    top: 6px;
    left: 12px;
  }
  .mgui-toggle-menu:hover .bar:nth-child(3){
    width: 15px;
    -webkit-transform: rotate(-30deg);
    transform: rotate(-30deg);
    top: 14px;
    left: 12px;
  }

  .mgui-userinfo{
    color:#333;
    line-height: 40px;
    margin-right: 20px;
  }
  .mgui-userinfo .mgui-button{margin-left:10px;}
  .mgui-userinfo .username{
    display: inline-block;
    /*padding: 0 10px;*/
  }
  .mgui-userinfo .avatar{
    width: 40px;
    height: 40px;
    border-radius: 40px;
    vertical-align: top;
  }

  .web-nav{display: inline-block;}
  .web-nav li{display: inline-block;cursor: pointer;}
  .web-nav a{text-decoration: none;display: inline-block;margin-right:40px;color:#333;position: relative;}
  .web-nav a:after{
    content: '';
    height: 2px;
    width: 0;
    display: block;
    background-color: #333;
    position: absolute;
    bottom: -4px;
    right: 0;
  }
  .web-nav a:after{
    animation: border-out .5s linear forwards;
  }
  .web-nav a.router-link-active:after{
    left: 0;right: auto;
    animation: border-in .5s linear forwards;
  }
  .web-nav .right a:after{
    left: 0;right: auto;
  }
  .web-nav .left a:after{
    left: auto;right: 0;
  }

  .web-nav a span{
    display: block;
  }
  .web-nav a span.en{font-size:16px;}
  .web-nav a span.cn{font-size:12px;color:#666;}
  .mgui-login .mgui-window-inner{
    width: 400px;
  }
  .mgui-login-other{
    font-size: 13px;
    line-height: 36px;
    color: #999;
  }
  .mgui-login-other a{text-decoration: none;color:#333;}

  .again-right-active {
    animation: again-right .5s reverse;
  }
  @keyframes border-in {
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  }
  @keyframes border-out {
    0% {
      width: 100%;
    }
    100% {
      width: 0;
    }
  }
  @keyframes again-right {
    0% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }
    50% {
      -webkit-transform: translateX(10px);
      transform: translateX(10px);
    }
    100% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }
  }

  @media (max-width: 640px) {
    .apps-header{
      padding:10px 15px;
    }
    .apps-header .logo{
      margin: 0;
      height:22px;
      line-height: 22px;
      font-size: 14px;
    }
    .apps-header .logo img{
      height: 22px;
    }
  }
</style>
